// extracted by mini-css-extract-plugin
export default {"dialog":"styles_dialog__pZhNk","header":"styles_header__UEJ0-","body":"styles_body__bu14v"};